import { observer } from 'mobx-react-lite'
import { Box, FullPageWrapper, SpinnerLoader, Typography } from 'shared/ui'
import {
  NotificationsProvider,
  useNotificationsContext,
} from 'pages/settings/pages/notifications/context/notificationsContext'
import { Options } from 'pages/settings/pages/notifications/ui/Options/Options'
import styles from './styles.module.scss'

const Notifications = observer(() => {
  const { initialLoading } = useNotificationsContext()

  if (initialLoading) return <SpinnerLoader ariaLabel={'NotificationsPage'} />

  return (
    <div className={styles.wrap}>
      <Box display='flex' flexDirection='column' gap='4px' padding='64px 20px 48px'>
        <Typography variant='heading-lg' ariaLabel='Notifications_title'>
          Notifications
        </Typography>
        <Typography
          variant='body-md-regular'
          ariaLabel='Notifications_subtitle_text'
          color='tertiary'
        >
          Manage your notifications preferences
        </Typography>
      </Box>
      <Options />
    </div>
  )
})

export const NotificationsPage = observer(() => (
  <FullPageWrapper className={styles.page}>
    <NotificationsProvider>
      <Notifications />
    </NotificationsProvider>
  </FullPageWrapper>
))
